const esriService = require('./src/esri-service');
const fastcastService = require('./src/fastcast-service');

module.exports = {
    esriService,
    fastcastService
};
